<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <VideoCover
          :aspect-ratio="videoAspectRatio"
          :gradient="RESOURCES_VIDEO_GRADIENT"
          :value="video"
          content-class="d-flex align-center justify-center"
          max-height="800"
          max-width="1600"
          style="position: relative"
        >
          <div
            class="text-right"
            style="position: absolute; top: 0; width: 100%"
          >
            <ShareLinkButton class="ma-1" variant="flat" />
          </div>

          <PlayVideo :video="video" />
        </VideoCover>
      </v-col>
    </v-row>

    <v-row cols="12">
      <v-col class="text-overline">
        <ResourceDate :value="video" /><span v-if="video.caption">
          | {{ video.caption }}</span
        >
      </v-col>
    </v-row>

    <v-row v-if="video.body">
      <v-col cols="12" xl="8">
        <!-- eslint-disable vue/no-v-html -->
        <div class="text-body-1" v-html="video.body"></div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="8">
        <ResourceTags :value="video" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { RESOURCES_VIDEO_GRADIENT } from '#root/lib/consts'

defineProps({
  video: {
    required: true,
    type: Object
  },
  value: {
    required: true,
    type: Object
  }
})

const videoAspectRatio = 16 / 9
</script>
